import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextareaComponent),
            multi: true
        }
    ],
    standalone: false
})
export class TextareaComponent implements ControlValueAccessor {
    private _disabled: boolean;
    @Input()
    set disabled(disabled: boolean | '') {
        this._disabled = disabled === '' || disabled;
    }
    get disabled(): boolean | '' {
        return this._disabled;
    }

    private _readonly: boolean;
    @Input()
    set readonly(readonly: boolean | '') {
        this._readonly = readonly === '' || readonly;
    }
    get readonly(): boolean | '' {
        return this._readonly;
    }

    @Input() cols = '';
    @Input() placeholder = '';
    @Input() rows = '';
    @Input() tabindex = '0';
    @Input() value = '';

    @Output() change = new EventEmitter<string>();
    @Output() input = new EventEmitter<string>();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onChange = (_: any): void => { };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onBlur = (): void => { };

    handleChange(event: any): void {
        this.input.emit(event.target?.value);
    }

    handleInput(event: any): void {
        this.value = event.target?.value;
        this.onBlur();
        this.onChange(this.value);
        this.input.emit(this.value);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onBlur = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    writeValue(value: any): void {
        if (value) {
            this.value = value || '';
        } else {
            this.value = '';
        }
    }
}
